import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eda63a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "master-detail-layout" }
const _hoisted_2 = { class: "list-panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "Education"),
    /*#__PURE__*/_createElementVNode("p", null, "Add your educational background")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_6 = { class: "list-item-content" }
const _hoisted_7 = { class: "list-item-title" }
const _hoisted_8 = { class: "list-item-subtitle" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "detail-panel"
}
const _hoisted_14 = { class: "form-grid" }
const _hoisted_15 = { class: "form-group col-span-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Course / Degree Title", -1))
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Institution", -1))
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Location", -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dates", -1))
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Grade/Classification", -1))
const _hoisted_25 = { class: "form-group col-span-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Specialism (Optional)", -1))
const _hoisted_27 = { class: "form-group col-span-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Modules Section Title", -1))
const _hoisted_29 = { class: "form-group col-span-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Modules", -1))
const _hoisted_31 = { class: "modules-list" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))

import { ref, computed, watch } from "vue";
import { VueDraggableNext } from "vue-draggable-next";
import type { Education } from "../../../../server/src/models/Resume";


export default /*#__PURE__*/_defineComponent({
  __name: 'EducationSection',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const education = ref<Education[]>([...props.modelValue]);
const selectedIndex = ref(0);

watch(
  () => props.modelValue,
  (newValue) => {
    education.value = [...newValue];
  },
  { deep: true }
);

const selectedEducation = computed(() => {
  if (!education.value.length) return null;
  return education.value[selectedIndex.value];
});

function addEducation() {
  education.value.unshift({
    instituteName: "",
    location: "",
    course: "",
    dates: "",
    specialism: "",
    gradeOrClassification: "",
    modulesTitle: "",
    modules: [
      {
        module: "",
        grade: "",
        uuid: crypto.randomUUID(),
      },
    ],
    uuid: crypto.randomUUID(),
  });
  selectedIndex.value = 0;
  emitUpdate();
}

function removeEducation(index: number) {
  education.value.splice(index, 1);
  if (selectedIndex.value >= education.value.length) {
    selectedIndex.value = Math.max(0, education.value.length - 1);
  }
  emitUpdate();
}

function addModule() {
  if (selectedEducation.value) {
    if (!selectedEducation.value.modules) {
      selectedEducation.value.modules = [];
    }
    selectedEducation.value.modules.push({
      module: "",
      grade: "",
      uuid: crypto.randomUUID(),
    });
    emitUpdate();
  }
}

function removeModule(index: number) {
  if (selectedEducation.value?.modules) {
    selectedEducation.value.modules.splice(index, 1);
    emitUpdate();
  }
}

function emitUpdate() {
  emit("update:modelValue", [...education.value]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(VueDraggableNext), {
        modelValue: education.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((education).value = $event)),
        group: "education",
        handle: ".drag-handle",
        tag: "div",
        class: "item-list",
        onChange: emitUpdate
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(education.value, (edu, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["list-item", { active: selectedIndex.value === index }]),
              onClick: ($event: any) => (selectedIndex.value = index)
            }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(edu.course || "New Course"), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(edu.instituteName || "Institution Name"), 1)
              ]),
              _createElementVNode("button", {
                class: "btn-remove",
                onClick: _withModifiers(($event: any) => (removeEducation(index)), ["stop"])
              }, _hoisted_11, 8, _hoisted_9)
            ], 10, _hoisted_4))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("button", {
        class: "btn-add-position",
        onClick: addEducation
      }, [
        _hoisted_12,
        _createTextVNode(" Add Education ")
      ])
    ]),
    (selectedEducation.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedEducation.value.course) = $event)),
                type: "text",
                placeholder: "e.g., Bachelor of Science in Computer Science",
                class: "form-control",
                onInput: emitUpdate
              }, null, 544), [
                [_vModelText, selectedEducation.value.course]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedEducation.value.instituteName) = $event)),
                type: "text",
                placeholder: "e.g., University of Cambridge",
                class: "form-control",
                onInput: emitUpdate
              }, null, 544), [
                [_vModelText, selectedEducation.value.instituteName]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedEducation.value.location) = $event)),
                type: "text",
                placeholder: "e.g., Cambridge, UK",
                class: "form-control",
                onInput: emitUpdate
              }, null, 544), [
                [_vModelText, selectedEducation.value.location]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedEducation.value.dates) = $event)),
                type: "text",
                placeholder: "e.g., Sep 2019 - Jun 2023",
                class: "form-control",
                onInput: emitUpdate
              }, null, 544), [
                [_vModelText, selectedEducation.value.dates]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedEducation.value.gradeOrClassification) = $event)),
                type: "text",
                placeholder: "e.g., First Class Honours",
                class: "form-control",
                onInput: emitUpdate
              }, null, 544), [
                [_vModelText, selectedEducation.value.gradeOrClassification]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedEducation.value.specialism) = $event)),
                type: "text",
                placeholder: "e.g., Artificial Intelligence",
                class: "form-control",
                onInput: emitUpdate
              }, null, 544), [
                [_vModelText, selectedEducation.value.specialism]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedEducation.value.modulesTitle) = $event)),
                type: "text",
                placeholder: "e.g., Key Modules, Relevant Coursework",
                class: "form-control",
                onInput: emitUpdate
              }, null, 544), [
                [_vModelText, selectedEducation.value.modulesTitle]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedEducation.value.modules, (module, mIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: module.uuid,
                    class: "module-item"
                  }, [
                    _hoisted_32,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((module.module) = $event),
                      type: "text",
                      class: "form-control",
                      placeholder: "Module name",
                      onInput: emitUpdate
                    }, null, 40, _hoisted_33), [
                      [_vModelText, module.module]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((module.grade) = $event),
                      type: "text",
                      class: "form-control grade-input",
                      placeholder: "Grade",
                      onInput: emitUpdate
                    }, null, 40, _hoisted_34), [
                      [_vModelText, module.grade]
                    ]),
                    _createElementVNode("button", {
                      class: "btn-remove-small",
                      onClick: ($event: any) => (removeModule(mIndex))
                    }, _hoisted_37, 8, _hoisted_35)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  class: "btn-add-module",
                  onClick: addModule
                }, [
                  _hoisted_38,
                  _createTextVNode(" Add Module ")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})